import { observer } from 'mobx-react';
import * as React from 'react';
import { ActiveProgram } from '../../../../ProgramStore/Types';
import { T } from '../../../../Translations';
import * as style from '../../../ProgramSummary/style.module.css';
import Percentage from './Percentage';

interface Props {
  programDetail: ActiveProgram;
}

const PercentComplete: React.FC<Props> = ({ programDetail }) => {
  return (
    <div className={style.progress}>
      <dl className={style.dl}>
        <dt className={style.progressLabel} data-test-progress-label={true}>
          <T kind="Progress" />
        </dt>
        <dd>
          <Percentage programDetail={programDetail} />
        </dd>
      </dl>
    </div>
  );
};

export default observer(PercentComplete);
